export enum TenantsEnum {
  PREDICTION = 'PREDICTION',
  STREAK = 'STREAK',
  BRACKET = 'BRACKET',
  SUPERSOCIAL = 'SUPER_SOCIAL',
  CONNECT3 = 'CONNECT3',
  PASS_THE_BALL = 'PASS_THE_BALL',
  MONEY_HEIST = 'MONEY_HEIST'
}
